module.exports = __webpack_public_path__ + "static/media/nike-the-mystery-of-giulia-gwinn.24d9f779.jpg";